import React, { useCallback, useMemo } from 'react';

import { Filter } from '@pkg/classes';
import { truncateContractAddress } from '@pkg/utils';

import { splitCamelCase } from '@app/helpers';
import { useNFTsFiltersStore } from '@app/store/zustand';

import { Wrapper } from './styles';

interface Props {
    filterKey: string;
    filterOption: string;
}

export const OptionButton = ({ filterKey, filterOption }: Props) => {
    let label = splitCamelCase(filterOption);

    if (filterKey === 'wallets') {
        label = truncateContractAddress(filterOption?.split('.')?.[1]);
    }

    const { currentFilters, setCurrentFilters } = useNFTsFiltersStore();
    const currentFilterValues = currentFilters.get(filterKey);

    const selected = useMemo(() => !!currentFilterValues?.includes(filterOption), [currentFilterValues, filterOption]);

    const handleClick = useCallback(() => {
        const updatedFilters = new Filter(currentFilters);

        if (selected) {
            updatedFilters.remove(filterKey, filterOption);
        } else {
            updatedFilters.set(
                filterKey,
                currentFilterValues ? [...currentFilterValues, filterOption] : [filterOption],
            );
        }

        setCurrentFilters(updatedFilters);
    }, [currentFilterValues, currentFilters, filterKey, filterOption, selected, setCurrentFilters]);

    return (
        <Wrapper $selected={selected} onClick={() => handleClick()}>
            {label}
        </Wrapper>
    );
};
